<form #form="ngForm" class="form-validate" (ngSubmit)="submit()">
  <div class="row mb-3">
    <label class="col-form-label col-auto">
      <i class="bi bi-database me-1"></i>ข้อมูลการลงทะเบียนที่ผิดปกติ
    </label>
  </div>
  <hr>
  <div class="row mb-3">
    <label for="report-type" class="col-xl-2 col-form-label">ประเภทรายงาน</label>
    <div class="col-xl-10">
      <select class="form-select" id="report-type" name="report-type" [(ngModel)]="params().arbitraryType">
        <option [ngValue]="undefined">เลือกทั้งหมด</option>
        <option value="OVER_HOUSE_NUMBER">1. รายงานการลงทะเบียนที่มีทะเบียนบ้านเลขที่เดียวกันเกิน 15 คน</option>
        <option value="IRREGULAR_SUM">2. รายงานการลงทะเบียนรายหน่วยบริการประจำที่มียอดผิดปกติ</option>
        <option value="OVER_ATTOR">3. รายงานสรุปข้อมูลการลงทะเบียนแทนกรณี รับมอบอำนาจมากกว่า 7 คน</option>
        <option value="TRANFER_UNIT">4. รายงานการลงทะเบียนเปลี่ยนหน่วยบริการจากสังกัดรัฐไปยังสังกัดเอกชน</option>
        <option value="IRREGULAR_TIME">5. รายงานการลงทะเบียนในช่วงเวลาที่ผิดปกติ</option>
      </select>
    </div>
  </div>
  <div class="row mb-3">
    <label for="zone" class="col-xl-2 col-form-label">เขตพื้นที่</label>
    <div class="col-xl-4">
      <app-select-zone id="zone" [disabled]="isZone" name="zone" [(ngModel)]="params().zone"></app-select-zone>
    </div>
    <label for="province" class="col-xl-2 col-form-label">จังหวัด</label>
    <div class="col-xl-4">
      <app-province-autocomplete id="province"
                                 name="province" [restrictZone]="params().zone"
                                 [(ngModel)]="params().province"></app-province-autocomplete>
    </div>
  </div>
  <div class="row mb-3">
    <label for="h-type" class="col-xl-2 col-form-label">สังกัดหน่วยงานที่ลงทะเบียน</label>
    <div class="col-xl-4">
      <select id="h-type" class="form-select" name="h-type" [(ngModel)]="params().hospitalType" (ngModelChange)="selectHospitalType()">
        <option [ngValue]="undefined">ทั้งหมด</option>
        <option *ngFor="let htype of hospitalType$ | async" [ngValue]="htype">{{htype.name}}</option>
      </select>
    </div>
    <label for="h-sub-type" class="col-xl-2 col-form-label">ประเภทหน่วยงานที่ลงทะเบียน</label>
    <div class="col-xl-4">
      <select id="h-sub-type" class="form-select" name="h-sub-type"
              [(ngModel)]="params().hospitalSubType">
        <option [ngValue]="undefined">ทั้งหมด</option>
        <option *ngFor="let subtype of params().hospitalType?.subTypes"
                [ngValue]="subtype">{{subtype.name}}</option>
      </select>
    </div>
  </div>
  <div class="row mb-3">
    <label for="hmainOp" class="col-xl-2 col-form-label">หน่วยบริการประจำที่ได้รับลงทะเบียน</label>
    <div class="col-xl-4">
      <app-hospital-autocomplete  [(ngModel)]="params().hmainOp" name="hmainOp" id="hmainOp"
                                  [restrictZoneId]="params()?.zone?.id"
                                  [restrictProvinceId]="params()?.province?.id"
                                  [restrictHTypeId]="params()?.hospitalType?.id"
                                  [restrictSubTypeId]="params()?.hospitalSubType?.id"></app-hospital-autocomplete>
    </div>
    <label for="status" class="col-xl-2 col-form-label">สถานะการตรวจสอบ</label>
    <div class="col-xl-4">
      <select class="form-select" id="status" name="status" [(ngModel)]="params().arbitraryStatus">
        <option [ngValue]="undefined">เลือกทั้งหมด</option>
        <option *ngFor="let item of arbitraryStatus " [ngValue]="item.k"> {{item.v}}</option>
      </select>
    </div>
  </div>
  <div class="row mb-3">
    <app-arbitrary-round [params]="params()"></app-arbitrary-round>
  </div>
  <div class="row mb-3">
    <div class="col-xl-6 text-center">
      <button type="submit" class="btn btn-primary me-3">
        <i class="bi bi-search me-1"></i>ค้นหา
      </button>
      <button type="button" (click)="reset()" class="btn btn-outline-secondary me-3">
        <i class="bi bi-eraser-fill me-2"></i>เคลียร์ข้อมูล
      </button>
    </div>
  </div>
  <div class="row mt-5">
    <div class="col-xl-8">
      <table class="table table-bordered">
        <thead>
        <tr>
          <th class="text-center table-active" scope="col">รอบที่</th>
          <th class="text-center table-active" scope="col">ข้อมูลลงทะเบียน</th>
          <th class="text-center table-active" scope="col">วันที่สามารถดาวน์โหลดข้อมูลได้</th>
          <th class="text-center table-active" scope="col">ระยะเวลากำกับติดตาม (30 วัน)</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th class="text-center" scope="row">1</th>
          <td>วันที่ 1-15 ของเดือน</td>
          <td>ตั้งแต่วันที่ 16 ของเดือน</td>
          <td>ตั้งแต่วันที่ 16 ของเดือน นับไปอีก 30 วัน</td>
        </tr>
        <tr>
          <th class="text-center" scope="row">2</th>
          <td>วันที่ 16-สิ้นเดือน</td>
          <td>ตั้งแต่วันที่ 1 ของเดือนถัดไป</td>
          <td>ตั้งแต่วันที่ 1 ของเดือนถัดไป นับไปอีก 30 วัน</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</form>
